


function updateCartCount() {
    // fetchが返すPromiseを直接返す
    return fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const cartCount = cart.item_count;
function addItemToCart(productId, quantity) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            id: productId,
            quantity: quantity,
        }),
    })
    .then(response => {
        if (response.ok) {
            return response.json();
        }
        throw new Error('Network response was not ok.');
    })
    .then(() => {
        // updateCartCountがPromiseを返すようになったので、thenメソッドを使ってチェーンできる
        return updateCartCount(); // ここでreturnを忘れずに
    })
    .then(() => {
        window.location.reload(); // ページのリロード
    })
    .catch(error => {
        console.error('Error adding item to cart:', error);
    });
}
        })
        .catch(error => {
            console.error('Error fetching cart:', error);
        });
}
